import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Tools({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M8.66699 2.66699C11.1808 2.66707 12.5681 3.57842 13.2959 4.61816C13.6471 5.11991 13.8218 5.61976 13.9092 5.99414C13.953 6.18199 13.9757 6.34117 13.9873 6.45703C13.9931 6.51508 13.9964 6.56322 13.998 6.59863C13.9989 6.61591 13.9997 6.63029 14 6.6416V6.66602V6.66699C13.9999 6.87598 13.9021 7.0733 13.7354 7.19922C13.5684 7.32514 13.3515 7.36498 13.1504 7.30762L13.1436 7.30566C13.1331 7.303 13.1139 7.29941 13.0889 7.29395C13.0386 7.28299 12.9618 7.26777 12.8652 7.25488C12.6693 7.22876 12.4043 7.21174 12.1201 7.24512C11.5655 7.31037 10.9685 7.55448 10.5967 8.29785C10.4838 8.52371 10.2525 8.66699 10 8.66699H8V20H9.33301V10H10.667V20.667C10.6668 21.035 10.3681 21.333 10 21.333H7.33301C6.96508 21.3328 6.66717 21.0349 6.66699 20.667V8.66699H4C3.63181 8.66699 3.33301 8.36819 3.33301 8V3.33301C3.33318 2.96497 3.63192 2.66699 4 2.66699H8.66699ZM4.66699 7.33301H9.61816C10.2569 6.36128 11.1928 6.01166 11.9639 5.9209C12.146 5.89949 12.3204 5.89427 12.4814 5.89551C12.4148 5.73241 12.3262 5.55628 12.2041 5.38184C11.7652 4.75503 10.8192 4.00008 8.66699 4H4.66699V7.33301Z"
        fill={iconColor}
      />
      <Path
        d="M18.667 2.66699C19.0349 2.66717 19.3328 2.96508 19.333 3.33301V7.33301C19.333 7.70109 19.035 7.99982 18.667 8H18V12H18.667C19.035 12.0002 19.333 12.2989 19.333 12.667V20.667C19.3328 21.0349 19.0349 21.3328 18.667 21.333H16C15.632 21.3329 15.3332 21.035 15.333 20.667V14.667H16.667V20H18V13.333H15.333V12.667C15.3331 12.2989 15.6319 12.0001 16 12H16.667V8H16C15.6318 8 15.333 7.7012 15.333 7.33301V3.33301C15.3332 2.96497 15.6319 2.66699 16 2.66699H18.667ZM16.667 6.66699H18V4H16.667V6.66699Z"
        fill={iconColor}
      />
    </Svg>
  );
}
